import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "bootstrap/dist/css/bootstrap.min.css";

// Inicializar Firebase
const functions = getFunctions();
const storage = getStorage();

function CompareInspector() {
  const getOpenAIResponse = httpsCallable(functions, "getOpenAIResponse");

  const [anaquelImage, setAnaquelImage] = useState(null);
  const [planogramaImage, setPlanogramaImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [resultado, setResultado] = useState("");
  const [error, setError] = useState(null);

  const handleImageUpload = (e, setImage) => {
    const file = e.target.files[0];
    setImage(file);
  };

  const handleRemoveImage = (setImage) => {
    setImage(null);
  };

  const uploadImageToStorage = async (file, folder = "probando") => {
    try {
        const storageRef = ref(storage, `${folder}/${file.name}`);
        await uploadBytes(storageRef, file);
        return await getDownloadURL(storageRef);
    } catch (err) {
        throw new Error(`Error al subir la imagen: ${err.message}`);
    }
};

const realizarComparacion = async () => {
    if (!anaquelImage || !planogramaImage) {
        alert("Debes seleccionar ambas imágenes: el anaquel y el planograma.");
        return;
    }

    setIsLoading(true);
    setError(null);

    try {
        // Subir imágenes a la carpeta 'probando' en Storage
        const anaquelUrl = await uploadImageToStorage(anaquelImage);
        const planogramaUrl = await uploadImageToStorage(planogramaImage);

        console.log("📤 Imágenes subidas:", { anaquelUrl, planogramaUrl });

        // Construcción de la conversación con URLs
        const conversation = [
            { role: "system", content: "JSON. Eres un asistente de una empresa de merchandising. Tu tarea es comparar dos imagenes. La primera imagen es un planograma de como se espera que esté organizado un anaquel. La segunda imagen es la foto directa del anaquel en la tienda. Tu deber es comparar ambas imagenes para corroborar que se cumpla con el planograma e indicar si se cumple o no (mostrar un mensaje que siga si se cumple con el planograma, o, no se cumple con el planograma). Además de eso, necesito que muestres el nombre del producto, la marca, el precio asociado al mismo, el color del producto, las unidades visibles del producto, y la ubicación en la segunda imagen, es decir en el anaquel. De no visualizarse alguno de estas características, debes poner un (No visible) o (No encontrado). También debes especificar, cuando compares ambas imagenes, que productos no se encuentran en el Anquel pero sí en el Planograma." },
            { role: "user", content: "JSON. Por favor, compara las dos imagenes, el Planograma y el Anquel y proporciona una descripción detallada de todos y cada uno de los productos visibles en el Anaquel, incluye nombre, marca, precio, unidades (cantidad de productos visibles en la imagen pero solo de la primera cara tanto en el Anaquel como en el Planograma, sin tener en cuenta los productos que están detras del anaquel, solo la primera cara visible en las dos imagenes) y ubicación. Si no puedes especificar alguno de los valores mencionados porque no se encuentran, coloca (No visible) o (No encontrado). También especifica el color del producto. También debes especificar, cuando compares ambas imagenes, que productos no se encuentran en el Anquel pero sí en el Planograma. Necesito que menciones cada producto una sola vez analiza la imagen del planograma como un todo, y el anaquel como un todo, como un bloque, para que así no dupliques información; de igual manera, haz una verificación a la respuesta que me diste y quita la información de productos duplicados. Muy importante, de no cumplirse el Planograma al comparar ambas imagenes, necesito que redactes una breve explicación del porqué no se cumple, ya sea por las marcas de los productos, o porque son productos diferentes los que se encuentran en el Planograma y en el Anaquel, cualquier información sobre porqué no se cumple. Además necesito que agregues un porcentaje de que tanto se cumple con el planograma, donde 100% es que se cumple por completo y 0% es que no se cumple para nada. Necesito esa informacion también para ver que tan parecidos están los anaqueles al planograma así que agrega eso a los detalles del porqué no coinciden. Si aparece una persona en el planograma o en el anaquel omitela por completo." },
            {
                role: "user",
                content: [
                    { type: "image_url", image_url: { url: planogramaUrl, detail: "high" } },
                    { type: "image_url", image_url: { url: anaquelUrl, detail: "high" } },
                ],
            },
        ];

        // Llamar a OpenAI con las URLs de Storage
        const response = await getOpenAIResponse({ conversation });

        console.log("✅ Respuesta OpenAI:", response.data);
        setResultado(JSON.stringify(response.data, null, 2));
    } catch (err) {
        console.error("❌ Error en la comparación:", err);
        setError(`Error al realizar la comparación: ${err.message}`);
    } finally {
        setIsLoading(false);
    }
};

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column bg-light py-5">
      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card shadow">
            <div className="card-body">
              <h2 className="card-title text-center text-primary mb-4">
                Comparar Anaquel vs Planograma
              </h2>

              <div className="mb-3">
                <label htmlFor="anaquel-input" className="form-label">Cargar imagen del Anaquel</label>
                <input id="anaquel-input" type="file" accept="image/*" onChange={(e) => handleImageUpload(e, setAnaquelImage)} className="form-control" />
              </div>

              {anaquelImage && (
                <div className="mb-3 text-center">
                  <img src={URL.createObjectURL(anaquelImage)} alt="Preview Anaquel" className="img-thumbnail w-50" />
                  <button className="btn btn-danger mt-2" onClick={() => handleRemoveImage(setAnaquelImage)}>Quitar imagen</button>
                </div>
              )}

              <div className="mb-3">
                <label htmlFor="planograma-input" className="form-label">Cargar imagen del Planograma</label>
                <input id="planograma-input" type="file" accept="image/*" onChange={(e) => handleImageUpload(e, setPlanogramaImage)} className="form-control" />
              </div>

              {planogramaImage && (
                <div className="mb-3 text-center">
                  <img src={URL.createObjectURL(planogramaImage)} alt="Preview Planograma" className="img-thumbnail w-50" />
                  <button className="btn btn-danger mt-2" onClick={() => handleRemoveImage(setPlanogramaImage)}>Quitar imagen</button>
                </div>
              )}

              <button className={`btn btn-success w-100 ${isLoading ? "disabled" : ""}`} onClick={realizarComparacion} disabled={isLoading}>
                {isLoading ? "Cargando..." : "Comparar"}
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-6 d-flex align-items-stretch">
  <div className="card shadow w-100">
    <div className="card-body d-flex flex-column">
      <h2 className="card-title text-center text-primary mb-4">
        Resultado de la Comparación
      </h2>
      {error && <p className="text-danger">{error}</p>}
      <div 
        className="bg-light p-3 border rounded w-100"
        style={{
          maxHeight: "400px",  // Altura máxima fija
          overflowY: "auto",   // Scroll solo vertical
          whiteSpace: "normal", // Evita desbordes de texto
          wordBreak: "break-word" // Rompe palabras largas en nuevas líneas
        }}
      >
        {resultado ? <pre className="m-0">{resultado}</pre> : <p className="text-muted">El resultado aparecerá aquí después del análisis.</p>}
      </div>
    </div>
  </div>
</div>


      </div>
    </div>
  );
}

export default CompareInspector;
